import Vue from 'vue'

export const showLoading = (state, payload) => {
    Vue.set(state, 'loading', payload)
}

export const setStatusOnline = (state, payload) => {
    Vue.set(state, 'online', payload)
}
